import { Translation } from './Translation';

export const zh_CN: Translation = {
  translation: {
    placeholders: {
      notApplicable: '不适用',
      placeholder: '占位符',
      dropdownDefault: '选择',
      typeToFilter: '键入以筛选',
      typeToSearch: '键入以搜索',
      textareaDefault: '在此处输入',
    },
    errors: {
      textLimit: '您已超过允许的字符数。请重新编辑，减少字符数。',
    },
    labels: {
      eLab: 'Azelis e-Lab',
      additionalInfo: '备注（例如标样、截止日期、其他目标国家/地区……）',
      price: '例如 2.50 - 2.89 {{currency}}/{{weightUnit}}',
      targetPackaging: '包装形式',
      notes: '备注',
      attachments: '附件',
      enterAName: '输入名称',
      addAttachment: '添加附件',
      optional: '可选',
      loading: '正在加载',
      briefing: {
        sent: '信息已发送',
        delivered: '信息已提交',
      },
      signIn: '登录',
      signOut: '注销',
      requestAccess: '请求访问',
      multiSelectHint: '可多选',
      other: '其他',
      noOptions: '无选项',
      or: '或',
      // e.g. 'Created at 12:00am 12.12.2021'
      createdAt: '创建于',
      createdBy: '创建者',
      status: '状态',
      continue: '继续',
      untitled: '未命名',
      countries: {
        Benelux: '比荷卢',
        Belgium: '比利时',
        France: '法国',
        Germany: '德国',
        India: '印度',
        Indonesia: '印度尼西亚',
        Italy: '意大利',
        Ireland: '爱尔兰',
        Luxembourg: '卢森堡',
        Netherlands: '荷兰',
        'United Kingdom': '英国',
      },
      languages: {
        de_DE: '德文',
        en_GB: '英文',
        en_US: '英文',
        fr_FR: '法文',
        zh_CN: '中国',
        ko_KR: '韩国人',
      },
      countrySlug: {
        BNL: '比荷卢',
        FR: '法国',
        GB: '英国',
        UK: '英国',
        DE: '德国',
        IN: '印度',
        IT: '意大利',
        ID: '印度尼西亚',
        IE: '爱尔兰',
      },
      markets: {
        AgriEnvironmental: '专业农业园艺',
        FoodNutrition: '食品与健康',
        HomeCareIndustrialCleaning: '家庭护理和工业清洁',
        HomecareIndustrialCleaning: '家庭护理和工业清洁',
        PersonalCare: '个人护理',
        SpecialtyAgriHorti: '',
        FoodHealth: '',
      },
      ofTotal: '共 {{total}} 个',
      perPage: '每页：',
      briefingFlowTag: {
        base: 'base',
        colour: 'colour',
        fragrance: 'fragrance',
        formulation: 'formulation',
      },
    },
    linksOrButtons: {
      details: '详情',
      // e.g. 'Back to Applications'
      backTo: '返回',
      seeProjectOverview: '查看项目概述',
      backToOverview: '返回概述',
      backToReview: '跳至查看',
      showMore: '显示更多',
      goToInspiration: '转到灵感部分',
      startNewFormulation: '开始全新配方',
      toggleMenu: '切换菜单',
      navigation: {
        start: '开始',
        'project-overview': '项目概述',
      },
      backToStart: '返回开始',
      edit: '编辑',
      next: '下一页',
      prev: '上一页',
      sendBriefing: '发送信息',
    },
    topics: {
      application: {
        name: '应用',
        heading: {
          create: '产品类别/最终用途？',
          fix: '您想改善的配方是什么产品类别？',
          enhance: '您想提升的配方是什么产品类别？',
          modify: '',
        },
        levels: {
          '0': {
            normal: '主要类别',
            selected: '主要类别',
            other: '指定类别',
            otherPlaceholder: '新的类别名称',
            product: 'Product category',
          },
          '1': {
            normal: '子类别',
            selected: '子类别',
            other: '指定类别',
            otherPlaceholder: '新的子类别名称',
            technology: 'Technology',
          },
          '2': {
            normal: '选择一个或多个特征',
            selected: '特征',
            endUse: 'End use',
            specifyEndUse: 'Specify your end use',
            endUsePlaceholder: 'End use name',
            other: '指定特征',
            otherPlaceholder: '新的特征',
          },
        },
      },
      'formulation-attributes': {
        name: '配方属性',
        heading: {
          general: '您的产品需要满足哪些属性？',
        },
        productMarketingClaims: '产品市场宣称',
        formulationType: '配方类型',
        texture: '质地',
        storage: '存储条件',
        productForm: '',
        otherProductMarketingClaims: '其他产品市场宣称',
        otherFormulationType: '其他配方类型',
        otherTexture: '其他质地',
        otherStorage: '其他存储条件',
        options: {
          availableProductMarketingClaims: {
            euEcolabel: 'EU Ecolabel',
            rspoCertified: 'RSPO Certified',
            bioBasedProduct: 'Bio-based product / natural derived',
            nordicSwan: 'Nordic Swan',
            euEcocert: 'EU Ecocert',
            lowCLP: 'Low CLP (classification)',
            lowToZeroVOC: 'Low to Zero VOC',
            biodegradable: '(Readily) biodegradable',
            lowAllergens: 'Low Allergens',
            highActive: 'High Active',
            nonLabelledForCLP: 'Non-Labelled for CLP',
            mildToSkinAndEyes: 'Mild to skin and eyes',
            easyToHandle: 'Easy to handle',
            highlyEffectiveLowDosageLevels:
              'Highly effective / low dosage levels',
            preservativeFree: 'Preservative free',
            foodContact: 'Food contact',
            noAnimalTesting: 'No animal testing',
            nanoparticlesFree: 'Nanoparticles free',
            lowSVHC: 'Low SVHC',
            natural: 'Natural',
            vegan: 'Vegan',
            noHeavyMetals: 'No heavy Metals',
            soothing: '舒缓',
            moisturising: '滋润',
            sensitiveSkin: '敏感皮肤',
            woundProtection: '伤口保护',
            calming: '镇定',
            waterSaving: '节水',
            antiageing: '抗衰老',
            softFocus: '软焦点',
            wrinkleFilling: '皱纹填充',
            antiCreasing: '耐皱',
            longLasting: '持久',
            easyToApply: '易于涂抹',
            quickDrying: '速干',
            waterProof: '防水',
            highCoverage: '高覆盖率',
            hydrating: '补水',
            oilAbsorbing: '吸油',
            nonBleedingFeathering: '不洇色/有毛须',
            glossy: '有光泽',
            kissProof: '吻不掉',
            rubResistant: '抗摩擦',
            removesWaterproof: '去除防水',
            gentle: '温和',
            wearResistant: '耐磨性',
            easyToRemove: '易于揭除',
            highGlossShine: '高光泽/光亮',
            dermatologicallyTested: '经过皮肤测试',
            antibacterial: '抗菌',
            forSensitiveSkin: '用于敏感肌肤',
            softening: '软化',
            detangling: '去缠结',
            dryDamaged: '干燥/损坏',
            fineHair: '细发',
            colourProtection: '颜色保护',
            colourEnhancing: '颜色增强',
            antiDandruff: '防头皮屑',
            conditioning: '调节',
            sulphateFree: '不含硫酸盐',
            antiBuildUp: '防堆积',
            twoInOne: '二合一',
            permanent: '永久性',
            semiPermanent: '半永久性',
            rootTouchUp: '根点触控',
            temporary: '临时',
            treatment: '治疗',
            hairStrengthening: '头发加固',
            revitalising: '焕然新生',
            exfoliating: '去角质',
            strengthening: '强化',
            damageRepair: '损坏修复',
            thickening: '增厚',
            protection: '保护',
            protecting: '保护',
            strongHold: '强固式',
            improvedComfort: '提高舒适度',
            foodseal: '食品密封',
            gumCare: '牙龈护理',
            whitening: '美白',
            alcoholFree: '无酒精',
            enamelCare: '牙釉质护理',
            sensitive: '敏感的',
            antiseptic: '防腐',
            antiBacterial: '抗菌',
            antiAgeing: '抗衰老',
            antioxidant: '抗氧化',
            antiPollution: '抗污染',
            repair: '修复',
            skinTightening: '肌肤紧致',
            illuminatingBrightning: '提亮',
            antiPuffinessDark: '抗浮肿/抗暗',
            cycles: '周期',
            purifying: '净化',
            oilControl: '控油',
            cooling: '冷却',
            extraFirmHold: '超固保持',
            firmHold: '牢固保持',
            lightHold: '轻度保持',
            curlDefining: '卷发定型',
            volumising: '丰盈',
            mediumHold: '介质保持',
            flexibleHold: '柔性保持',
            shine: '光亮',
            weatherproof: '防风雨',
            uvProtection: '紫外线防护',
            waterResistant: '耐水',
            floral: '花卉',
            fougère: '馥奇',
            aromatic: '芳香',
            woody: '木质',
            citrus: '柑橘色',
            amber: '琥珀色',
            chypre: '檀香型',
            fruity: '果香',
            gourmand: '美食家',
            musk: '麝香',
            spicy: '辛辣',
            cleanLabel: '清洁标签',
            naturalColours: '天然色泽',
            naturalFlavours: '天然风味',
            glutenFree: '无麸质',
            allergenFree: '无过敏原',
            palmFree: '无棕榈',
            nanoFree: '无纳米',
            noReducedFat: '无脂/低脂',
            noReducedSugar: '无糖/低糖',
            noReducedSalt: '无盐/低盐',
            sourceHighFiber: '纤维来源/高含量',
            sourceHighProtein: '蛋白质来源/高含量',
            sourceHighVitaminsMinerals: '维生素和矿物质的来源/高含量',
            healthBenefices: '健康益处',
            veganVegetarianAnimalFree: '严格素食/素食/不含动物成分',
            organic: '有机',
            fairTrade: '公平交易',
            halal: '清真',
            kosher: '犹太洁食',
            sweatReduction: '땀 발생 억제',
            odourProtection: '땀 냄새 방어',
            aluminiumFree: '알루미늄 프리',
            noWhitening: '안티 화이트닝',
            invisible: '인비저블',
            refreshing: '리프레싱',
            moisturizing: '모이스처라이징',
          },
          availableFormulationTypes: {
            owEmulsion: '水包油乳液',
            woEmulsion: '油包水乳液',
            waterBased: '水基',
            oilBased: '油基',
            emulsion: '乳液',
            anhydrous: '无水',
            alcoholic: '酒精',
            nonAlcoholic: '不含酒精',
            other: '其他',
            solidStick: '고체 스틱',
            gelStick: '겔 스틱',
            aerosolSpray: '에어로졸 스프레이',
            nonAerosolSpray: '논에어로졸 스프레이',
            cream: '크림',
            rollOn: '롤온',
            powder: '파우더',
          },
          availableTextures: {
            fluid: '液体',
            spray: '喷剂',
            serum: '浆液',
            aerosol: '喷雾剂',
            gel: '凝胶',
            lotion: '乳液',
            cream: '膏状物',
            solid: '固体',
            foam: '泡沫',
            powder: '粉末',
            liquid: '液体',
            tablet: '片剂',
            stick: '棒',
            bar: '条形',
            nonAerosol: '非喷雾剂',
            other: '其他',
            soft: '부드러운',
            emulsion: '에멀젼',
          },
          availableStorage: {
            ambient: '常温',
            bakeryDryBlend: '烘干',
            instantDryBlend: '干混',
            frozen: '冷冻',
            bestBefore: '保质期',
            pasteurisation: '巴氏灭菌法',
            chilled: '冷藏',
            bakeStability: '烘烤稳定性（微波）',
          },
          availableProductForm: {
            powder: 'Powder',
            liquid: 'Liquid',
            granules: 'Granules',
            flakes: 'Flakes',
            paste: 'Paste',
            wax: 'Wax',
            prills: 'Prills',
            needles: 'Needles',
            piece: 'Piece',
            emulsion: 'Emulsion',
          },
        },
        errors: {
          productMarketingClaims: '产品的市场宣称',
        },
      },
      fragrance: {
        name: 'Fragrance',
        heading: {
          general: 'Fragrance your formulation',
        },
        fragranceFormulation:
          'Do you want to have your formulation fragranced?',
        attributesFulfill: 'Which attributes should your fragrance fulfill?',
        requirements:
          'Are there any requirements that the fragrance needs to comply to?',
        colourOrConcept: 'Concept / Colour',
        CMR: 'CMR (Carcinogenic, mutagenic and reprotoxic)',
        direction: 'Fragrance direction',
        mustComply: 'Fragrance must comply to',
        maxAllergensOnLabel: 'Max amount allergens on label',
        requestedApplicationDosage: 'Requested application dosage (in %)',
        fragranceSamples: 'Is there a need for fragrance samples?',
        requiredSampleTime: {
          heading: 'What is the required timing you need the sample by?',
          label: 'Required sample time',
        },
        largerFragranceSize: {
          heading:
            'Please specify if you need a larger fragrance sample size than 10gr per sample.',
          label: 'Larger sample size',
        },
        specifyFragranceMustOther: 'Specify other',
        options: {
          confirmFragranceOptions: {
            yes: 'Yes',
            no: 'No',
          },
          availableColoursOrConcepts: {
            black: 'Black',
            silver: 'Silver',
            white: 'White',
            blue: 'Blue',
            yellow: 'Yellow',
            pink: 'Pink',
            purple: 'Purple',
            green: 'Green',
            orange: 'Orange',
            gold: 'Gold',
            natural: 'Natural',
            clean: 'Clean',
            care: 'Care',
            hygiene: 'Hygiene',
            malodour: 'Malodour',
            performance: 'Performance',
            premium: 'Premium',
          },
          availableDirection: {
            citrus: 'Citrus',
            chypre: 'Chypre',
            floral: 'Floral',
            floriental: 'Floriental',
            fruity: 'Fruity',
            gourmand: 'Gourmand',
            green: 'Green',
            herbal: 'Herbal',
            lavender: 'Lavender',
            musk: 'Musk',
            oriental: 'Oriental',
            pine: 'Pine',
            spicy: 'Spicy',
            woody: 'Woody',
          },
          availableCMR: {
            notAllowed: 'Not allowed',
            allowedButOilNotLabelled: 'Allowed but oil not labelled CMR',
            allowed: 'Allowed',
          },
          mustComply: {
            noAllergensOnOil: 'No allergens on oil',
            noAllergensOnFinalProduct: 'No allergens on final product',
            pCMNMFree: 'PCM/NM free',
            ecoLabel: 'Ecolabel',
            okotestCandidate: 'Okotest candidate',
            vegan: 'Vegan',
            other: 'Other',
          },
        },
      },
      'processing-capabilities': {
        name: '工艺要求',
        heading: {
          general: '您的产品有哪些工艺要求？',
        },
        bakeStability: '烘烤稳定性',
        bakingTime: '烘烤时间（分钟）',
        bakingTemperature: '烘烤温度（°C）',
        fillingTime: '灌装时间（分钟）',
        fillingTemperature: '灌装温度（°C）',
        mixingStepDetails: '混合步骤的具体描述（高剪切/桨式搅拌）',
        productPh: '产品 pH 值',
        brix: '糖度（可溶性固体）',
        processingCapabilitiesPackagingDetails: '包装的类型和细节描述',
        foodSafetyDetails: '食品安全（巴氏灭菌法/UHT）',
        processingHotCold: '冷加工/热加工',
        homogenisation: '均质',
        otherProcessingCapabilities: '其他工艺要求',
      },
      restrictions: {
        name: '限制',
        heading: {
          general: '配方是否有特别的要求？',
        },
        requirements: '要求',
        restrictions: '限制',
        can: '可以',
        must: '必须',
        mustComply: '配方必须符合',
        canComply: '配方可以符合',
        requirementsMust: '要求 - 必须',
        requirementsCan: '要求 - 可以',
        restrictionsMust: '限制 - 必须',
        restrictionsCan: '限制 - 可以',
        specifyRequirements: '特定要求',
        specifyRestrictions: '特定限制',
        options: {
          silictions: '无有机硅',
          parabens: '无对羟基苯甲酸酯',
          oil: '不含矿物油成分',
          emulsifier: '无乳化剂',
          preservatives: '无防腐剂',
          ethanol: '无乙醇',
          cold: '冷加工',
          polymore: '无合成聚合物',
          uv: '无有机紫外滤光片',
          nanomaterial: '无纳米材料',
          sulfate: '无硫酸盐',
          surfactant: '表面活性剂含量低',
          tears: '无泪液配方',
          talc: '无滑石粉',
          notApplicable: '不适用',
          other: '其他',
        },
        errors: {
          restrictions: '加载限制时出错',
        },
      },
      requirements: {
        name: 'Requirements',
        heading: {
          general:
            'Are there any requirements that the formulation needs to comply to?',
          specify: 'Please specify your further formulation requirements',
        },
        requirements: 'Requirements',
        can: 'Can',
        must: 'Must',
        mustComply: 'Formulation must comply to',
        canComply: 'Formulation can comply to',
        requirementsMust: 'Requirements - Must',
        requirementsCan: 'Requirements - Can',
        specifyRequirements: 'Specify requirements',
        applicationConditionDetails: {
          heading:
            'Please indicate details on the application conditions (Type of surface or soil, temperature range …).',
          label: 'Application condition details',
        },
        pHRange: {
          heading: 'In which pH range the product needs to be active?',
          label: 'phRange',
        },
        aggressiveComponents: {
          heading:
            'Please list the potential aggressive components in the formulation.',
          label: 'Aggressive components',
        },
        lightStability: {
          heading: 'Is light stability important?',
          label: 'Light stability',
          answer: {
            yes: 'Yes',
            no: 'No',
          },
        },
        options: {
          biodegradable: '(Readily) biodegradable',
          bioBased: 'Bio-based product / natural derived',
          carBody: 'Car body shop compliant',
          coldPress: 'Cold process',
          easyToHandle: 'Easy to handle',
          euEcocert: 'EU Ecocert',
          euEcolabel: 'EU Ecolabel',
          foodContact: 'Food contact',
          halal: 'Halal',
          highActive: 'High active',
          highlyEffectiveLowDosageLevels:
            'Highly effective / low dosage levels',
          kosher: 'Kosher',
          lowAllergens: 'Low Allergens',
          lowCLP: 'Low CLP (classification)',
          lowSVHC: 'Low SVHC',
          lowToZeroVOC: 'Low to Zero VOC',
          mildToSkinAndEyes: 'Mild to skin and eyes',
          nanoparticlesFree: 'Nanoparticles free',
          natural: 'Natural',
          noAnimalTesting: 'No animal testing',
          noHeavyMetals: 'No heavy metals',
          nonLabelledForCLP: 'Non-Labelled for CLP',
          nordicSwan: 'Nordic Swan',
          palmFree: 'Palm free',
          phosphorFree: 'Phosphor free',
          preservativeFree: 'Preservative free',
          rspoCertified: 'RSPO Certified',
          vegan: 'Vegan',
          notApplicable: 'Not applicable',
          other: 'Other',
        },
        errors: {
          requirements: 'Error loading requirements',
        },
      },
      colour: {
        name: 'Colour',
        heading: {
          general: 'Colour your formulation',
        },
        formulationColoured: 'Do you want to have your formulation coloured?',
        colourAttributes: 'Which attributes should your colourant fulfill?',
        colourShades: 'Colour Shades',
        colourSamples: {
          label: 'Colour samples',
          heading: 'Is there a need for colour samples?',
        },
        requiredTime: {
          heading: 'What is the required timing you need the sample by?',
          label: 'Required sample time',
        },
        labSupport: {
          heading: 'Do you require support from the Miliken lab? ',
          label: 'Support from the supplier lab required?',
        },
        options: {
          confirmColourOptions: {
            yes: 'Yes',
            no: 'No',
          },
          shades: {
            cyanBlue: 'Cyan Blue',
            royalBlue: 'Royal Blue',
            darkBlue: 'Dark Blue',
            brightBlue: 'Bright Blue',
            aquamarineBlue: 'Aquamarine Blue',
            brightGreen: 'Bright Green',
            green: 'Green',
            brightYellow: 'Bright Yellow',
            lemonYellow: 'Lemon Yellow',
            darkYellow: 'Dark Yellow',
            yellow: 'Yellow',
            orange: 'Orange',
            fluorescentYellow: 'Fluorescent Yellow',
            brightViolet: 'Bright Violet',
            purple: 'Purple',
            darkViolet: 'Dark Violet',
            darkRed: 'Dark red',
            fluorescentPink: 'Fluorescent Pink',
            brightPink: 'Bright Pink',
            softPink: 'Soft Pink',
          },
        },
      },
      'target-consumer': {
        name: '目标消费者',
        heading: {
          general: '您的目标消费者是哪些人群？',
        },
        age: '年龄',
        targetConsumerAge: '目标消费者年龄',
        gender: '性别',
        targetConsumerGender: '目标消费者性别',
        buttons: {
          genders: {
            female: '女',
            male: '男',
            allGenders: '所有性别',
          },
          allAges: '所有年龄段',
        },
      },
      'additional-info': {
        name: '其他信息',
        heading: {
          general: '你还有要补充的内容吗？',
        },
        additionalInfo: '其他信息',
        additionalInfoFiles: '其他信息文件',
      },
      price: {
        name: '价格',
        heading: {
          general: '您预计的配方成本是多少？',
          base: 'What are your estimated base formulation costs?',
          color: 'What are your estimated additional colour costs?',
          fragrance: 'What are your estimated additional fragrance costs?',
        },
      },
      'product-details': {
        name: 'Product Details',
        heading: {
          general: 'Please specify your product details.',
        },
        finishedProductSamples: {
          heading: 'Is there a need for samples of the finished product?',
          answer: {
            yes: 'Yes',
            no: 'No',
          },
          requiredTimeForSample: 'If yes, required time for sample',
        },
        finishedProductPotential:
          'What is the finished product potential? (t/year)',
        projectDeadline: 'Project deadline',
      },
      packaging: {
        name: '包装',
        heading: {
          general: '您的包装形式是什么？',
        },
        options: {
          pumpDispenser: '压泵式包装',
          sprayDispenser: '喷雾器',
          jar: '广口瓶',
          tube: '管',
          aerosol: '喷雾剂',
          sachet: '香囊',
          bagInCan: '罐内套袋',
          airPump: '空气泵',
          bag: '包',
          carton: '纸箱',
          bottle: '瓶',
          compact: '紧凑',
          jarBottle: '罐瓶',
          other: '其他',
        },
      },
      'modification-type': {
        name: 'Modification Type',
        heading: {
          general: 'Which parts of your formulation do you want to modify?',
          type: 'Modification type',
        },
        options: {
          base: 'Modify base formulation',
          colour: 'Modify colour',
          fragrance: 'Modify fragrance',
        },
      },
      'modification-issue': {
        name: 'Modification',
        heading: {
          general: 'What is the modification you want to make?',
        },
        explainIssue: 'Please explain your issue',
      },
      problem: {
        name: '问题',
        fix: {
          name: '改善',
        },
        enhance: { name: '提升' },
        heading: {
          fix: '您的配方在哪些方面需要改进/调整？',
          enhance: '您希望提升配方的哪些方面？',
        },
      },
      ingredients: {
        name: '原料',
        heading: {
          general: '您目前在配方中使用哪些原料？',
        },
        azelisRawMaterials: 'Azelis 原材料',
        rawMaterials: '原材料',
        rawMaterial: '原材料',
        rawMaterialFiles: '原材料文件',
        ingredientsFiles: '原料文件',
        upload: '在此处上传您的配方,或在下面添加原料。',
        other: '其他材料（例如水、二氧化硅、辛乙二醇……）',
      },
      'active-ingredients': {
        name: 'Active ingredients',
        heading: {
          general: 'What is the active ingredient of the formulation?',
        },
        chooseActiveIngredient: 'Choose active ingredient',
        concentration: 'Concentration [g/L]',
        addAnother: 'Add another active ingredient',
      },
      'active-function': {
        name: 'Active function',
        heading: {
          general:
            'Do you want to add further ingredients to your formulation?',
          review: 'Function',
        },
        adjuvant: {
          name: 'Adjuvant',
          choose: 'Choose adjuvant',
        },
        stabilizer: {
          name: 'Stabilizer',
          choose: 'Choose stabilizer',
        },
        emulsifier: {
          name: 'Emulsifier',
          choose: 'Choose emulsifier',
        },
        liquidColorant: {
          name: 'Liquid colorant',
          choose: 'Choose liquid colorant',
        },
        solvent: {
          name: 'Solvent',
          choose: 'Choose solvent',
        },
      },
      formulations: {
        name: '配方',
      },
      review: {
        name: '复核',
      },
    },
    modals: {
      cancelBriefing: {
        prompt: '是否要取消输入的信息？',
        content: '所有现有输入将丢失。',
        confirm: '是',
        cancel: '否',
      },
      customerSelection: {
        prompt: '指定用户',
        content: '请选择您要为其进行配方研制的客户和客户的联络人',
        form: {
          customer: '客户',
          customerUser: '客户联络人',
        },
        confirm: '确认',
        cancel: '取消',
        footer:
          '如果您想离开 Azelis e-Lab，您可以在此处<link1 label="注销" />或访问 <link2 label="Azelis 客户门户网站" />',
        error: {
          heading: '出错了',
          messages: {
            loadingCustomer: '我们无法加载客户选项。',
            loadingCustomerUser: '我们无法加载此客户的联络人。',
            settingCustomerUser: '为该用户加载客户配置文件时出现问题。',
          },
          content:
            '请重试。如果问题仍然存在，请尝试注销并再次登录，或<link1 label="联系 Azelis 支持部门" />.',
          confirm: '请重试',
          cancel: '请注销并重试',
          cannotSelectEmployeeUsers: '无法选择员工用户',
        },
      },
      changeCustomerSelection: {
        change: '变更',
        prompt: '是否要更改您当前的用户角色？',
        confirm: '是，更改',
        cancel: '继续',
      },
      deleteUploadedFile: {
        prompt: '是否要删除文件？',
        confirm: '是，删除',
        cancel: '取消',
      },
    },
    components: {
      briefingSelection: {
        heading: '您希望如何开始？',
        buttons: {
          create: {
            title: '创建',
            copy: '新的配方',
          },
          enhance: {
            title: '提升',
            copy: '现有配方',
          },
          modify: {
            title: '提升',
            copy: '现有配方',
          },
          fix: {
            title: '改善',
            copy: '现有配方',
          },
        },
        inspirationLink: '从配方库中获取灵感',
        loading: '正在加载必要的数据，请稍候',
      },
      stepPackaging: {
        packagingSamplePrompt:
          '如果您有可用的包装，请将其发送给我们，以便我们根据您的需求来优化配方。请附上您的姓名和项目名称，以便我们将其与您的项目相匹配。',
        addressLabel: '地址',
        otherPackaging: '指定其他包装',
      },
      review: {
        heading: '复核',
        productName: '我的项目名称',
      },
      success: {
        // The \n here creates a new line, and should not be translated
        heading: '谢谢！\n查询发送成功。',
        emailInfo: '已将摘要发送到您的电子邮件地址。',
        whatsNext: {
          heading: '下一步是什么？',
          review: '您的项目将由我们的技术专家审核。',
          contact: '您的客户经理将很快与您联系。',
        },
        recommendations: {
          heading: '需要更多灵感？',
          subheading: '以下是符合您应用的几种配方和成分：',
          noDescription: '无描述',
        },
      },
      projectOverview: {
        heading: '配方概述',
        emptyFormulations: '您似乎还没有任何配方',
        createFormulation: '创建配方',
        myFormulations: '我的配方',
        // {{team}} = customer name or translation from 'team' below
        teamFormulations: '{{team}} 配方',
        team: '团队',
        filter: {
          country: '按国家或地区筛选',
          market: '按市场筛选',
          application: '按应用筛选',
        },
        resetAllFilters: '清除所有筛选器',
      },
      projectDetails: {
        projectType: {
          heading: '项目类型',
          create: '创建新配方',
          enhance: '提升现有配方',
          fix: '改善现有配方',
        },
        referenceId: '参考 ID',
        formulationSpecifics: '配方详情',
        fileDownloadHelp:
          '如果在新选项卡中打开文件，请使用 ctrl + s（在 Windows 上）或 cmd + s（在 Mac 上）以保存文件',
      },
      account: {
        heading: '您的帐户',
        name: '名称',
        email: '电子邮件地址',
        selectedMarket: '选定市场',
      },
      fileUpload: {
        fileListLabel: '已附加的文件',
        privacy:
          '您的数据上传是完全安全的，不会与任何第三方共享。它们仅将由 Azelis 在项目中使用，以确保为您提供最佳结果。',
      },
      customerSelectionBar: {
        onBehalf: '您正在为所选客户进行配方研制：',
      },
      intro: {
        heading: {
          main: '借助全新的 Azelis e-Lab，您可以轻松获取我们的专业技术知识。',
          about: '关于 e-Lab',
        },
        content: {
          main: '全新的 Azelis e-Lab 是创造新配方,或改进现有配方的优选智能方式。通过直接联系我们的技术专家，可以有效缩短您的上市流程！',
          benefits: [
            '改善或提升现有配方',
            '创造新配方',
            '直接联系 Azelis 技术专家',
            '全天候可访问',
            '立即开始！',
          ],
        },
      },
      signIn: {
        passwordLabel: '密码',
        email: '电子邮件地址',
        // $t(labels:requestAccess) = 'Request access', from the further up translation string
        signUp: '没有帐户？$t(labels:requestAccess)!',
        loginWithCustomerPortal: '使用客户门户登录',
        pleaseWait: '正在登录，请稍候。',
        errors: {
          errorEmpty: '请输入电子邮件和密码',
          errorIncorrect: '输入的电子邮件和密码组合不正确。',
          errorServerside: '发生错误，请稍后重试……',
          errorCustomerPortalLogin: '我们无法访问您的客户门户资料。',
          access_denied: '似乎权限被拒绝。请重试。',
        },
      },
      footer: {
        partOfAzelis: 'Azelis 客户门户的一部分',
        copyright: '版权所有 © Azelis {{year}}。保留所有权利。',
        links: {
          cookie: 'Cookie 声明',
          privacy: '隐私声明',
          terms: '使用条款',
        },
      },
      countryMarketSelector: {
        reason: {
          empty: {
            heading: '未选择国家/地区或市场',
            body: '您尚未选择国家/地区或市场。请从下面的可用选项中选择一项：',
            universalCustomer: {
              heading: '未选择客户、国家/地区或市场',
              body: '您尚未选择客户、国家/地区或市场。请从下面的可用选项中选择一项：',
            },
          },
          invalid: {
            heading: '选择的国家/地区或市场无效',
            body: '您选择的国家/地区或市场无效。请从下面的可用选项中选择一项：',
            universalCustomer: {
              heading: '选择无效',
              body: '您选择的客户、国家/地区或市场无效。请从下面的可用选项中选择一项：',
            },
          },
          preferences: {
            heading: '偏好',
            body: '请记住，更改您的偏好将影响您可用的内容。',
          },
        },
        customer: '公司',
        country: '国家/地区',
        market: '市场',
        preferredLanguage: '首选语言',
        confirm: '确认',
        cancel: '取消',
      },
      error404: {
        heading: '找不到页面',
        body: '我们在该 URL 上找不到任何内容。请尝试使用菜单导航或再次检查您的链接。',
      },
      noCountryMarketAvailable: {
        heading: '找不到有效的国家/地区或市场',
        body: '您的用户资料似乎与 e-Lab 支持的任何国家或地区/市场细分无关。请联系您的系统管理员。',
      },
      filters: {
        filter: '筛选器',
      },
    },
    emails: {
      customer: {
        subject: '已收到 Azelis e-Lab 配方信息',
        html: {
          introNotCreatedByEmployee:
            // {{branch}} = ‘create’, ‘fix’ or ‘enhance’
            // {{branchFormulationPrefix}} = ‘a new’ or ‘an existing’
            '谢谢！已成功将您的 {{branch}} {{branchFormulationPrefix}} 项目发送给 Azelis 技术专家。',
          introCreatedByEmployee:
            // Same as above
            '{{employeeCreatorName}} 代表您创建了一个项目给 {{branch}} {{branchFormulationPrefix}}。已成功将其发给 Azelis 技术专家。',
          newFormulationPrefix: '新的配方',
          existingFormulationPrefix: '现有配方',
          heading: '在 e-Lab 上创建了新简报',
          // {{customerName}} = e.g 'John Smith'
          line1: '尊敬的 {{customerName}},',
          line2: '我们的专家团队将立即阅读您的信息，并将很快与您联系。',
          line3: '您可以在下方,找到已提供给我们的信息的摘要。',
          referenceId: '参考 ID',
          projectName: '项目名称',
          marketSegment: '市场细分',
          country: '国家/地区',
          thankYou: '感谢您使用 Azelis e-Lab。',
          inspirationLinkText: '灵感',
          inspirationSuggestion:
            // {{inspirationLink}} = just the word 'inspiration', but it's a link
            '如果您不想错过您所在行业的最新趋势，以及我们的 Azelis 专家,提供的新市场洞察，请务必访问我们的{{- inspirationLink}} 板块。',
          theAzelisTeam: 'Azelis 团队',
          copyright: '版权所有 © Azelis {{year}}。保留所有权利。',
        },
      },
      lab: {
        // {{byDisplayName}} = either 'John Smith' or 'John Smith for Sam Samson'
        subject: 'Azelis e-Lab 配方，作者 {{byDisplayName}}',
        // {{byMe}} and {{forMe}} are both just names
        byFor: '{{byMe}} （用于 {{forMe}}',
        html: {
          line1:
            // {{branch}} = 'create', 'fix' or 'enhance'
            // {{branchFormulationPrefix}} = 'a new' or 'an existing'
            // {{byDisplayName}} = same as above
            '{{branch}} {{branchFormulationPrefix}} 的新简报由 {{byDisplayName}} 发布在 Azelis e-Lab 上。',
          referenceId: '参考 ID：',
          createdAt: '创建时间：',
          projectName: '项目名称：',
          pleaseContact:
            // {{- mailToLink}} = an email address, but it's also a link
            '请联系 {{- mailToLink}} 以讨论更多详情。',
          unnamedProject: '未命名项目',
          yourAzelisTeam: '您的 Azelis e-Lab 团队',
        },
      },
      auxiliary: {
        // will be inserted for {{branch}} in the emails section
        branch: {
          create: '创建',
          enhance: '提升',
          modify: '提升',
          fix: '改善',
        },
      },
    },
  },
};
